module.exports = __webpack_public_path__ + "static/media/logo.10e45229.png";